/* eslint-disable */
import Paginator from 'paginator';

export default (perPage = 100) => {
  if (Number.isNaN(Number(perPage))) {
    throw new Error('Erro ao paginar');
  }
  if (perPage < 1 || perPage > 100) {
    perPage = 100;
  }

  const paginator = new Paginator(perPage);

  return (nResults = 0, page = 1) => {
    if (Number.isNaN(Number(nResults)) || Number.isNaN(Number(perPage))) {
      throw new Error('Erro ao paginar');
    }

    if (page < 1 || page > 50000) {
      page = 1;
    }
    return {
      ...paginator.build(nResults, page),
      data: [],
    };
  };
};
